import { router } from 'expo-router';
import { StyleSheet } from 'react-native';

import { InlineChallengeAlert } from '@fhs/loyalty/src/components';
import { useEvaluateChallenges } from '@fhs/loyalty/src/queries/loyalty.queries';
import { Button, Skeleton } from '@fhs/ui';
import { InlineAlert } from '@fhs-legacy/universal-components';
import { routes } from 'utils/routing';

export function CartChallengeInlineAlert() {
  const { data, isLoading } = useEvaluateChallenges();

  const firstChallengeData = data?.[0];

  if (isLoading) {
    return <Skeleton style={styles.skeleton} />;
  }

  if (firstChallengeData) {
    if (firstChallengeData.errors && firstChallengeData.errors[0]?.message) {
      return (
        <InlineAlert
          title={firstChallengeData.name}
          status="error"
          message={firstChallengeData.errors[0].message}
          style={styles.container}
        />
      );
    }

    if (firstChallengeData.warnings && firstChallengeData.warnings[0]?.message) {
      return (
        <InlineAlert
          isDismissable
          title={firstChallengeData.name}
          status="warning"
          message={firstChallengeData.warnings[0].message}
          style={styles.container}
          action={
            <Button
              type="unstyled"
              size="xs"
              onPress={() => router.navigate(routes.offersV2)}
              style={styles.button}
            >
              <Button.Text>See Challenge</Button.Text>
            </Button>
          }
        />
      );
    }

    if (firstChallengeData?.evaluationMessage) {
      return (
        <InlineChallengeAlert
          style={styles.container}
          message={firstChallengeData.evaluationMessage}
          name={firstChallengeData.name ?? ''}
        />
      );
    }
  }

  return null;
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 24,
    borderRadius: 8,
  },
  skeleton: {
    height: 69,
    borderRadius: 8,
    marginBottom: 24,
  },
  button: {
    alignSelf: 'flex-end',
    marginTop: 4,
  },
});
